// import { toggleConnectedNodes } from '../App.vue';

export const graphConfig = {
    // 交互相关配置
    interaction: {
        // 节点相关
        node: {
            enableDrag: false,
            tooltipFormat: node => `
        <p class="scene-tooltip" style="padding: 0.267rem 0.4rem; font-size: 0.4rem">
  <u><b>ID:</b></u> ${node.id} <br> 
  <u><b>Term:</b></u> ${node.term} <br>
  <u><b>Category:</b></u> ${node.category} <br>
  ${
                node.group
                    ? `<u><b>${node.type === 'Variation' ? "Gene:" : "Group:"}</b></u> ${node.group} <br>`
                    : ``
            }
  ${
                node.largegroup
                    ? `<u><b>Pathway:</b></u> ${node.largegroup} <br>`
                    : ``
            }
  ${
                node.title
                    ? `<u><b>Cosine:</b></u><br>` +
                    node.title
                        .split(";")
                        .map(line => `&nbsp;&nbsp;&nbsp;&nbsp;${line.trim()}`)
                        .join("<br>")
                    : ``
            }
</p>
      `
        },

        // Variation - gene
        // node.type phenotype - group

        // 连线相关
        // &larr;&rarr;
        link: {
            tooltipFormat: link => `
        <p class="scene-tooltip" style="padding: 0.267rem 0.4rem; font-size: 0.4rem">
          <strong><u>FROM</u></strong>:
          ${link.source.term} (${link.source.id})<br/>
          <strong><u>TO</u></strong>:
          ${link.target.term} (${link.target.id})<br/>
          <strong><u>Cosine Similarity</u></strong>: 
          ${(link.weight).toFixed(3)}
        </p>
      `
        },

        // 背景颜色
        backgroundColor: '#202124'
    }
};

export const labelConfig = {
    maxFontSize: 0.5,
    minFontSize: 0.3,
    minVisibleNum: 48,
    maxVisibleNum: 56,
}

// 透明度调整框的调整步长
export const opacitySettingPath = 5;

// 图形在执行zoomToFit后图形边缘节点与画布边距。数值越小则图像约大
export const cameraFramePadding = -580;

// 图中边的最小长度
export const minLinkLength = 100;

// 图中节点的最大最小缩放倍数
export const maxNodeScale = 16;
export const minNodeScale = 2;
export const centerNodeFontsize = 0.8;

// 初始相机方位角
export const initCameraAngle = {x: 0, y: 0, z: -4}